export const INTERNAL_OPERATOR_SESSION_KEY = 'oasix_internal_operator_session';

export function setInternalOperatorSession(active: boolean): void {
  if (typeof window === 'undefined') return;
  if (active) {
    window.sessionStorage.setItem(INTERNAL_OPERATOR_SESSION_KEY, '1');
  } else {
    window.sessionStorage.removeItem(INTERNAL_OPERATOR_SESSION_KEY);
  }
}

export function isInternalOperatorSessionActive(): boolean {
  if (typeof window === 'undefined') return false;
  return window.sessionStorage.getItem(INTERNAL_OPERATOR_SESSION_KEY) === '1';
}
